import moment from "moment";
export function validateAge(birthday, showFallback) {
  const dob = moment(birthday, showFallback ? "DD/MM/YYYY" : "YYYY-MM-DD");
  const now = moment();
  const difference = now.diff(dob, "year", true);
  return isNaN(difference) ? undefined : difference >= 18 && difference < 120;
}
export const validateEmail = email => {
  const re = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;
  return re.test(email);
};
export const validatePassword = password => {
  const re2 = /^(?=.{8,}$)(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9]).*$/;
  return re2.test(password);
};
export function requiredError(field, errorText = "is required") {
  return `${field} ${errorText}`;
}
export function minError(field, length, errorText = "must be at least", type = "characters") {
  return `${errorText} ${length} ${type}`;
}
export function maxError(field, length, errorText = "must be at most", type = "characters") {
  return `${errorText} ${length} ${type}`;
}